<div class="flex flex-col items-start gap-4 py-4 md:border-bottom bg-white">
    <div class="flex w-full justify-between items-center">
        <div class="flex items-center gap-4">
            <h2 class="text-xl text-black font-bold">موقعیت مکانی</h2>
        </div>

            <button mat-button color="primary" class="icon-arrow-button !hidden md:!flex !pe-0 items-center"
            (click)="handleMarkertClickEvent()">
                <span class="text-blue-500 text-sm !font-medium">مشاهده ویلا و اقامتگاه روی نمایش نقشه</span>
                <i class="ico-Left !text-2xl text-blue-500"></i>
            </button>
    </div>

    <div class="h-[250px] w-full relative">
        <div id="map-ecolodge" class="h-full w-full rounded-lg shadow-inner !z-0 "></div>
    </div>

    <div class="flex items-center gap-2 text-black-300">
        <i class="ico-Location text-[20px]"></i>
        <p>آدرس دقیق و شماره همراه میزبان پس از پرداخت برای شما ارسال خواهد شد.</p>
    </div>



        <button mat-button color="primary" class="icon-arrow-button md:!hidden" (click)="handleMarkertClickEvent()">
            <span>نمایش نقشه</span>
            <i class="ico-Left !text-2xl text-blue-500"></i>
        </button>
</div>